import React from 'react';
import { Phone, CheckCircle, AlertTriangle, Lightbulb, Snowflake } from 'lucide-react';
export function TravelTrailerRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7250">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7251">
        <div className="container mx-auto px-4" data-id="element-7252">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7253">
            RV and Trailer Repair Service
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7254">
            Plumbing Repair • Generator Repair • Wiring Repair • Tow Bars • Roof
            Repair
          </p>
          <p className="text-lg text-gray-100 text-center mt-2" data-id="element-7255">
            Restorations • Detailing • Propane Systems • Boat Loaders • Overload
            Springs
          </p>
          <p className="text-lg text-gray-100 text-center" data-id="element-7256">
            Weight Distribution • Sway Control • Self-Adjusting Air-Ride Systems
            • Hitches
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7257">
        <div className="max-w-6xl mx-auto" data-id="element-7258">
          {/* Services Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7259">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7260">
              Complete RV & Trailer Services
            </h2>

            <div className="grid md:grid-cols-3 gap-4" data-id="element-7261">
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7262">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7263" />
                <span className="text-gray-700" data-id="element-7264">Plumbing Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7265">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7266" />
                <span className="text-gray-700" data-id="element-7267">Generator Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7268">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7269" />
                <span className="text-gray-700" data-id="element-7270">Wiring Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7271">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7272" />
                <span className="text-gray-700" data-id="element-7273">Tow Bars</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7274">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7275" />
                <span className="text-gray-700" data-id="element-7276">Roof Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7277">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7278" />
                <span className="text-gray-700" data-id="element-7279">Restorations</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7280">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7281" />
                <span className="text-gray-700" data-id="element-7282">Detailing</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7283">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7284" />
                <span className="text-gray-700" data-id="element-7285">Propane Systems</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7286">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7287" />
                <span className="text-gray-700" data-id="element-7288">Boat Loaders</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7289">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7290" />
                <span className="text-gray-700" data-id="element-7291">Overload Springs</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7292">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7293" />
                <span className="text-gray-700" data-id="element-7294">Weight Distribution</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7295">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7296" />
                <span className="text-gray-700" data-id="element-7297">Sway Control</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7298">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7299" />
                <span className="text-gray-700" data-id="element-7300">
                  Self-Adjusting Air-Ride Systems
                </span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7301">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7302" />
                <span className="text-gray-700" data-id="element-7303">Hitches</span>
              </div>
            </div>
          </div>

          {/* Winterization Tips */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7304">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7305">
              <Snowflake className="mr-3 text-blue-600" size={32} data-id="element-7306" />
              Winterization Tips
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-7307">
              <div data-id="element-7308">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7309">
                  To prepare your rig's plumbing systems for winter storage
                </h3>

                <div className="space-y-4" data-id="element-7310">
                  <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-7311">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7312">
                      1. Drain all tanks
                    </p>
                    <p className="text-gray-700" data-id="element-7313">
                      Flush out the black water and gray water tanks and be sure
                      to get them as empty as possible. Drain the fresh water
                      tank.
                    </p>
                  </div>

                  <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-7314">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7315">
                      2. Drain the water heater
                    </p>
                    <p className="text-gray-700" data-id="element-7316">
                      Drain the water heater and close the drain valve.
                    </p>
                  </div>

                  <div className="bg-purple-50 border-l-4 border-purple-500 p-4" data-id="element-7317">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7318">
                      3. Drain fresh water plumbing system
                    </p>
                    <p className="text-gray-700" data-id="element-7319">
                      Use low point drains if provided. Open all faucets and
                      step on the toilet pedal as well. Get as much water out of
                      the system as possible. Close the low point drains.
                    </p>
                  </div>

                  <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-7320">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7321">
                      4. Winterize appliances
                    </p>
                    <p className="text-gray-700" data-id="element-7322">
                      If your rig is equipped with an icemaker or washer/dryer,
                      follow the manufacturer's recommended procedures to
                      winterize and protect these appliances.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center" data-id="element-7323">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Spree_RV_Trailer.jpg?opt=w3" alt="RV Trailer" className="rounded-lg shadow-md max-w-full h-auto" data-id="element-7324" />
              </div>
            </div>
          </div>

          {/* Mouse Damage Warning */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-7325">
            <div className="flex items-start mb-6" data-id="element-7326">
              <AlertTriangle className="text-red-600 mr-4 flex-shrink-0 mt-1" size={32} data-id="element-7327" />
              <div data-id="element-7328">
                <h2 className="text-2xl font-bold text-red-900 mb-4" data-id="element-7329">
                  Protect Your RV from Mouse Damage
                </h2>
                <p className="text-lg text-gray-800 mb-4" data-id="element-7330">
                  If mice have infested your home-away-from-home, then{' '}
                  <strong data-id="element-7331">your vehicle is prone to the expensive damage</strong>{' '}
                  resulting from mice chewing through wiring and nesting in
                  vital components.
                </p>
                <p className="text-gray-800" data-id="element-7332">
                  Even worse, you and your family could be prone to offensive
                  odors, potential messes and even disease.
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-7333">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/chewed-wires.jpg?opt=w3" alt="Chewed wires from mouse damage" className="mx-auto rounded-lg shadow-sm" data-id="element-7334" />
            </div>
          </div>

          {/* Helpful Tips */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7335">
            <div className="flex items-center justify-center mb-6" data-id="element-7336">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/mouse.jpg?opt=w3" alt="Mouse" className="mr-4" data-id="element-7337" />
              <h2 className="text-4xl font-bold text-gray-900 flex items-center" data-id="element-7338">
                <Lightbulb className="mr-3 text-yellow-500" size={40} data-id="element-7339" />
                Helpful Tips
              </h2>
            </div>

            <div className="space-y-6" data-id="element-7340">
              <div className="bg-green-50 border-l-4 border-green-500 p-6" data-id="element-7341">
                <p className="text-gray-800 italic mb-2" data-id="element-7342">
                  <strong data-id="element-7343">
                    "We have had two Trailers next to each other, one protected
                    with dryer sheets, the other not, the one without the dryer
                    sheets was destroyed by mice, the one with the dryer sheets
                    was clean as a whistle, and smelled pretty good, to boot.
                    The dryer sheets really, truly work."
                  </strong>
                </p>
                <p className="text-gray-600 italic text-right" data-id="element-7344">- Karen Short</p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6" data-id="element-7345">
                <p className="text-gray-800 italic mb-2" data-id="element-7346">
                  <strong data-id="element-7347">
                    "I put bounty dryer sheets in all the corners and in the
                    cupboards. I have done this for the last 5 years and I have
                    had zero problems with mice."
                  </strong>
                </p>
                <p className="text-gray-600 italic text-right" data-id="element-7348">- Kevin Brown</p>
              </div>

              <div className="bg-yellow-50 border-2 border-yellow-500 rounded-lg p-6 text-center" data-id="element-7349">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7350">
                  Simple Mouse Prevention Solution
                </h3>
                <p className="text-lg text-gray-800" data-id="element-7351">
                  Place dryer sheets in corners, cupboards, and storage areas to
                  keep mice away naturally and keep your RV smelling fresh!
                </p>
              </div>
            </div>
          </div>

          {/* Service Categories */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7352">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7353">
              Our RV & Trailer Expertise
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-7354">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-7355">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7356">
                  Systems & Mechanical
                </h3>
                <ul className="space-y-2" data-id="element-7357">
                  <li className="flex items-start" data-id="element-7358">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7359" />
                    <span className="text-gray-700" data-id="element-7360">
                      Plumbing systems repair and winterization
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7361">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7362" />
                    <span className="text-gray-700" data-id="element-7363">
                      Generator service and repair
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7364">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7365" />
                    <span className="text-gray-700" data-id="element-7366">
                      Electrical wiring and systems
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7367">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7368" />
                    <span className="text-gray-700" data-id="element-7369">
                      Propane system inspection and repair
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-7370">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7371">
                  Exterior & Structural
                </h3>
                <ul className="space-y-2" data-id="element-7372">
                  <li className="flex items-start" data-id="element-7373">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7374" />
                    <span className="text-gray-700" data-id="element-7375">
                      Roof repair and resealing
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7376">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7377" />
                    <span className="text-gray-700" data-id="element-7378">Complete restorations</span>
                  </li>
                  <li className="flex items-start" data-id="element-7379">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7380" />
                    <span className="text-gray-700" data-id="element-7381">
                      Professional detailing
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7382">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7383" />
                    <span className="text-gray-700" data-id="element-7384">Structural repairs</span>
                  </li>
                </ul>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-7385">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7386">
                  Towing & Suspension
                </h3>
                <ul className="space-y-2" data-id="element-7387">
                  <li className="flex items-start" data-id="element-7388">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7389" />
                    <span className="text-gray-700" data-id="element-7390">
                      Tow bar installation and service
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7391">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7392" />
                    <span className="text-gray-700" data-id="element-7393">
                      Weight distribution systems
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7394">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7395" />
                    <span className="text-gray-700" data-id="element-7396">
                      Sway control installation
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7397">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7398" />
                    <span className="text-gray-700" data-id="element-7399">
                      Air-ride suspension systems
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-7400">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7401">
                  Accessories & Upgrades
                </h3>
                <ul className="space-y-2" data-id="element-7402">
                  <li className="flex items-start" data-id="element-7403">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7404" />
                    <span className="text-gray-700" data-id="element-7405">Boat loader systems</span>
                  </li>
                  <li className="flex items-start" data-id="element-7406">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7407" />
                    <span className="text-gray-700" data-id="element-7408">
                      Overload spring installation
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7409">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7410" />
                    <span className="text-gray-700" data-id="element-7411">
                      Hitch installation and service
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7412">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7413" />
                    <span className="text-gray-700" data-id="element-7414">
                      Custom upgrades and modifications
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7415">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7416">
              Expert RV & Trailer Repair Services
            </h2>
            <p className="text-xl mb-6" data-id="element-7417">
              Complete service, repair, and winterization for your home away
              from home
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7418">
              <Phone className="mr-3" size={24} data-id="element-7419" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7420">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}